
  
// Script Généré le : 10/01/2026 10:38:10 via ModelGenerator.nt
//  Country.ts
// Chemin de sortie : ..\..\..\front-shared\paf-shared\projects\ngx-paf-common\src\lib\Models\Country.ts

export class Country {

  // int Id
  public Id: number=0;

  // string LblCod
  public LblCod?: string=null;

  // string CountryCod2
  public CountryCod2?: string=null;

  // string CountryCod3
  public CountryCod3?: string=null;

  // int? CurrencyId
  public CurrencyId?: number=null;

  // string LngCod
  public LngCod?: string=null;

  // byte TopUE
  public TopUE: number=0;

  // byte Active
  public Active: number=0;
}